import React, { useState, useEffect, useRef } from "react";
import "./RecordsSidebar.css";
import Select from "react-select";
import Prescription from "../../../../../assets/Prescription.png";
import Pathology from "../../../../../assets/Pathology Reports.png";
import Hospital from "../../../../../assets/Hospital Records.png";
import Medical from "../../../../../assets/Medical Images.png";
import Vaccination from "../../../../../assets/Vaccination.png";
import MedicalCert from "../../../../../assets/Medical.png";
import { Link, useParams } from "react-router-dom";
import * as utils from "../../../../../Utils";
import { useApp } from "./../../../../../AppProvider";

// ✅ RecordCard outside to prevent unmount/remount on every render
const RecordCard = ({ record }) => {
  const { recordId } = useParams();
  const isActive = record.recordId === recordId;

  const logos = {
    PrescriptionRecord: Prescription,
    PathologyRecord: Pathology,
    RadiologyRecord: Medical,
    VaccinationRecord: Vaccination,
    HospitalizationRecord: Hospital,
    MedicalCertificateRecord: MedicalCert,
  };
  const logo = logos[record.typeOfRecord] || Pathology;

  return (
    <Link
      className="linkRecord"
      to={`/DashboardDashboardNavigation/records/${record.recordId}`}
    >
      <div className={`record-sidrbar__cards ${isActive ? "active-card_record_sidebar" : ""}`}>
        <div className="flex">
          <img src={logo} className="icon-1" alt="reports" />
          <div className={isActive ? "afterActive" : "beforActive"}>
            <p className="date-text">{utils.formatDate(record.dateOfPublish)}</p>
          </div>
        </div>
        <div className="blood">
          <h1 className="main-heading">{record.typeOfRecord}</h1>
          <ul className="ul">
            {/* {record.typeOfRecord === "PathologyRecord" &&
              record.testValues &&
              record.testValues
                .filter((item) => item.classification === "Abnormal")
                .slice(0, 3)
                .map((item, index) => (
                  <li key={index} className="sidebar-record_medicine">
                    {item.testName}: <span className="detail1">{item.value}</span>
                  </li>
                ))}
            {record.typeOfRecord === "PrescriptionRecord" &&
              record.medications &&
              record.medications.slice(0, 4).map((item, index) => (
                <li key={index} className="sidebar-record_medicine">
                  {index + 1}. {item.drugsName}
                </li>
              ))} */}
            {/* Pathology */}
            {record.typeOfRecord === "PathologyRecord" && record.testValues?.filter((item) => item.classification === "Abnormal")
              .slice(0, 3).map((item, index) => (
                <li key={index}>{item.testName}: <span className="detail1">{item.value}</span></li>
              ))}
            {/* Radiology */}
            {record.typeOfRecord === "RadiologyRecord" && (
              <>
                {record.typeOfRadiologyRecord &&
                  <li>Radiology Type: <span className="detail1">{record.typeOfRadiologyRecord}</span></li>}
                {record.diagnosedArea?.length > 0 &&
                  <li>Diagnosed Area: <span className="detail1">{record.diagnosedArea.join(", ")}</span></li>}
                {record.symptoms?.length > 0 &&
                  <li>symptoms: <span className="detail1">{record.symptoms.slice(0, 2).join(", ")}</span></li>}
              </>
            )}
            {/* Prescription */}
            {record.typeOfRecord === "PrescriptionRecord" && record.medications?.slice(0, 4).map((item, index) => (
              <li key={index} className="prescription-sidebar-medicine">
                {index + 1}. {item.drugsName}
              </li>
            ))}
            {/* Medical Certificate */}
            {record.typeOfRecord === "MedicalCertificateRecord" && (
              <>
                {record.certificateType && (
                  <li>Type: <span className="detail1">{record.certificateType}</span></li>
                )}
                <li>
                  Fit for Duty:{' '}
                  <span className="detail1">{record.fitForDuty ? 'Yes' : 'No'}</span>
                </li>
                {record.leaveDays && (
                  <li>Leave: <span className="detail1">{record.leaveDays} day{record.leaveDays !== 1 ? 's' : ''}</span></li>
                )}
              </>
            )}
          </ul>
          <div className="record-sidebar__diagnosis-main-container">
            {record.diagnosis?.map((item, index) =>
              item ? (
                <p key={index} className="record-sidebar__capsule">{item}</p>
              ) : null
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};

function RecordsSidebar() {
  const { patientsMHR } = useApp();
  const scrollRef = useRef(null);
  const scrollPos = useRef(0);

  const options = [
    { value: "PathologyRecord",         label: "Pathology" },
    { value: "RadiologyRecord",         label: "Radiology" },
    { value: "VaccinationRecord",       label: "Vaccination" },
    { value: "PrescriptionRecord",      label: "Prescription" },
    { value: "HospitalizationRecord",   label: "Hospitalization" },
    { value: "MedicalCertificateRecord", label: "Medical Certificate" },
  ];

  const [selectedOption, setSelectedOption] = useState(null);

  // ✅ Restore scroll position after every render
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    el.scrollTop = scrollPos.current;
  });

  const handleScroll = () => {
    scrollPos.current = scrollRef.current?.scrollTop || 0;
  };

  const filteredData = (selectedOption
    ? (patientsMHR || []).filter((record) => record.typeOfRecord === selectedOption.value)
    : (patientsMHR || [])
  ).sort((a, b) => new Date(b.dateOfPublish) - new Date(a.dateOfPublish));

  return (
    <div
      className="main-container"
      ref={scrollRef}
      onScroll={handleScroll}
    >
      <div className="h1">
        <h1>Records</h1>
      </div>
      <div className="records-dropdown">
        <Select
          className="records-dropdown-1"
          options={options}
          value={selectedOption}
          onChange={setSelectedOption}
          placeholder="Select Record"
          isClearable={true}
        />
      </div>
      <div className="card-main">
        {filteredData.length > 0
          ? filteredData.map((record) => (
            <RecordCard key={record.recordId} record={record} />
          ))
          : <p className="recordNotFound-sidebar">Records not found for the selected type.</p>}
      </div>
    </div>
  );
}

export default RecordsSidebar;